import { atom } from 'recoil'

import { capacitorPreferencesEffect } from '@/capacitor/recoil/capacitor-preferences-effect'

/**
 * Atom to store the elapsed time since the last interaction
 */
const elapsedTimeAtom = atom<number | undefined>({
  key: '@app/local-timer',
  default: undefined,
  effects: [capacitorPreferencesEffect('@app/local-timer')],
})

export { elapsedTimeAtom }
